import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import UploadDocsView from "./UploadDocsView";
import { Helpers } from "./helpers";
import { ServiceContext } from "src/services/provider/Service.provider";
export function UploadDocsContainer(props: RouteComponentProps<any>) {
  const services = useContext(ServiceContext);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);
  const helpers = new Helpers(setLoading, setData, services);

  useEffect(() => {
    helpers.fetch();
  }, []);

  return <UploadDocsView loading={loading} data={data} setLoading={setLoading} helpers={helpers} />;
}
export default withRouter(UploadDocsContainer);



// WEBPACK FOOTER //
// ./src/pages/monitor/upload/UploadDocsContainer.tsx